import { api } from './api'
import type { RecordingState } from '@/stores/meeting'

/**
 * §45–49, 2026-09-14 경량 구현(client-canvas). Cloudflare Realtime 트랙을 서버가 직접 받아
 * 합성하는 Option A(docs/MEET_MEDIA_001_VALIDATION.md)는 api.kei.bio가 이미 메모리 압박
 * 상태(3.7GB 중 2.5GB 사용+스왑)라 보류하고, kei-broadcast 미디어 서버는 이 시점에 SSH 자체가
 * 응답하지 않아 자원 확인이 불가능했다 — 사용자 지시로 "호스트 브라우저가 캔버스로 Stage를
 * 그려 MediaRecorder로 녹화하고 R2에 직접 업로드"하는 경량 구조로 전환. 이 파일은 그 경량 구조의
 * REST 계약만 담당: 실제 녹화 바이트는 이 서비스를 거치지 않고 uploadUrl로 브라우저→R2 직접 PUT.
 */

export interface RecordingStatus {
  state: RecordingState
  masterUrl: string | null
}

export interface RecordingUploadUrl {
  uploadUrl: string
  fileUrl: string
  contentType: string
}

export const recordingApi = {
  start: (meetingId: string) => api.post<{ ok: true; state: RecordingState }>(`/api/meet/rooms/${meetingId}/recording/start`),
  stop: (meetingId: string) => api.post<{ ok: true; state: RecordingState }>(`/api/meet/rooms/${meetingId}/recording/stop`),
  status: (meetingId: string) => api.get<RecordingStatus>(`/api/meet/rooms/${meetingId}/recording`),
  getUploadUrl: (meetingId: string, ext: 'webm' | 'mp4') =>
    api.post<RecordingUploadUrl>(`/api/meet/rooms/${meetingId}/recording/upload-url`, { ext }),
  complete: (meetingId: string, fileUrl: string) =>
    api.post<{ ok: true; state: RecordingState; masterUrl: string }>(`/api/meet/rooms/${meetingId}/recording/complete`, { fileUrl }),
  fail: (meetingId: string) => api.post<{ ok: true; state: RecordingState }>(`/api/meet/rooms/${meetingId}/recording/fail`)
}
